import * as React from 'react';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { LandingGrammar } from '@doltech/modules/lib/grammar/landing/LandingGrammar';

interface LandingGrammarTemplatePageProps extends DynamicPageProps {}

const LandingGrammarTemplatePage = (props: LandingGrammarTemplatePageProps) => {
  return <LandingGrammar {...props} />;
};

export default LandingGrammarTemplatePage;


